import { useMemo } from 'react'
import { ContentImage, ContentText, ContentVideo } from './content-types'
import { ContentSlideShow } from './content-types/ContentSlideShow'
import styled from 'styled-components'
import { mq } from '@/styles'
import { ContentButtonDownload } from './content-types/ContentButtonDownload'

const ContentsTypes = {
  'text': (data) => (<ContentText data={data} />),
  'medium_image': (data) => (<ContentImage data={data} />),
  'medium_video': (data) => (<ContentVideo data={data} />),
  'download': (data) => (<ContentButtonDownload data={data} />),
  'slideshow': (data) => (<ContentSlideShow data={data} />)
}


const getContentByType = (content) => {
  const { type } = content || {}
  if (!content || !type || !ContentsTypes[type]) return <></>
  return (ContentsTypes[type](content))
}

export const Content = ({ content, isMulticolumn, isThreeColumn }) => {
  const ContentByType = useMemo(() => getContentByType(content), [content])

  return (
    <ContentArticle className={`${content.type} ${isMulticolumn ? 'multicolumn' : ''} ${isThreeColumn ? 'three_column' : ''}`} $col={content.col}>
      {ContentByType}
    </ContentArticle>
  )
}

const ContentArticle = styled.article<{ $col?: { from: number, expand: number } }>`
  display: flex;
  justify-content: center;
  grid-column: 1 / span 6;

  &.spacer {
    margin: 0;
  }

  &.text,
  &.download,
  &.button,
  &.slideshow,
  &.medium_image,
  &.medium_video {
    grid-column: 1 / span 6;

    ${mq.greaterThan('tablet')} {
      grid-column: ${({ $col }) =>`${$col.from} / span ${$col.expand}`};
    }

    &.three_column {
      grid-column: span 2;

      ${mq.greaterThan('tablet')} {
        grid-column: ${({ $col }) =>`${$col.from} / span ${$col.expand}`};
      }

      &.medium_image,
      &.medium_video {
        figure {
          min-height: 160px;

          ${mq.greaterThan('tablet')} {
            min-height: 350px;
          }
        }
      }
    }

    &.multicolumn {
      grid-column: span 3;

      ${mq.greaterThan('tablet')} {
        grid-column: ${({ $col }) =>`${$col.from} / span ${$col.expand}`};
      }
    }

    figure {
       img {
        height: auto !important;
       }
    }
  }


  
  &.media,
  &.fullscreen {
    margin: 0 auto;
    position: relative;

    figure {
      background-color: #EFEFEF;
    }
  }

  &.slider,
  &.slideshow,
  &.fullscreen {
    grid-column: 1 / span 6;

    ${mq.greaterThan('tablet')} {
      grid-column: ${({ $col }) =>`${$col.from} / span ${$col.expand}`};
    }

  }

  &.media {
    grid-column: 1 / span 6;

    ${mq.greaterThan('tablet')} {
      grid-column: ${({ $col }) =>`${$col.from} / span ${$col.expand}`};
    }

    figure {
      height: 100%;
      width: 100%;
    }

    img {
      height: 100%;
      object-fit: cover;
    }

    
  }

  &.empty {
    display: none;
  }
`
